import { inject, singleton } from "tsyringe";
import { Module } from "../../common/module";
import { ExtensionContext } from "../../common/models/extension-config";
import { CommonModule } from "../common.module";
import { ApiModule } from "../common/api/api.module";

@singleton()
export class WalkmeModule extends Module {
  public name: string = "WalkmeModule";
  public acceptedLicenseFlags: string[] = ["NetflixIntegrations"];
  public shouldRun(context: ExtensionContext): boolean {
    return (
      context === ExtensionContext.vizportal || this.common.isStandaloneVizQL()
    );
  }
  constructor(
    @inject(CommonModule) private common: CommonModule,
    @inject(ApiModule) private apiModule: ApiModule
  ) {
    super([common, apiModule]);
  }

  public async run(): Promise<void> {
    const walkmeScript = await this.apiModule.apiRequest((e) =>
      e.apiCustomNxTableauIntegrationWalkmeScript(window.stm.config.serverId)
    );
    if (!walkmeScript.success) {
      this.log.e(
        "Failed to request WalkMe integration script",
        walkmeScript.error
      );
      return;
    }
    if (!walkmeScript.value.hasWalkMeIntegration) {
      this.log.i("WalkMe integration is disabled");
      return;
    }
    const el = document.createElement("div");
    el.innerHTML = walkmeScript.value.walkMeScript;
    let c = 0;
    const length = el.children.length;
    for (let i = 0; i < length; i++) {
      const child = el.children.item(i);
      const newWrap = document.createElement("script");
      newWrap.setAttribute("type", "text/javascript");
      switch (child.nodeName.toLocaleLowerCase()) {
        case "script":
          const textNode = document.createTextNode(child.innerHTML);
          newWrap.appendChild(textNode);
          if ((child as HTMLScriptElement).src) {
            newWrap.src = (child as HTMLScriptElement).src;
          }
          break;
        case "#text":
          newWrap.appendChild(child);
          break;
        default:
          this.log.e(
            `Failed to append child to document as it's not a script or text tag`,
            child.innerHTML
          );
          continue;
      }
      document.head.appendChild(newWrap);
      c++;
    }
    this.log.i(
      `WalkMe integration enabled. ${c} script elements were appended`
    );
  }
}
